import Organization from "./Organization";
import VulSource from "./VulSource";
import VulView from "./VulView";

export type InterestRestrictionType = "NONE" | "ALLOW_SOURCES" | "BLOCK_SOURCES" | "VIEW";

class Interest {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public name?: string,
        public description?: string,
        public organization?: Organization,
        public restrictionType?: InterestRestrictionType,
        public restrictedSources?: VulSource[],
        public restrictedView?: VulView,
        public generatedAiAttributeId?: string,
        public generatedAiExtractorId?: string,
        public generatedVulViewId?: string,
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const entity = new Interest();

        entity.id = data.id;
        entity.createdAt = data.createdAt ? new Date(data.createdAt) : undefined;
        entity.name = data.name;
        entity.description = data.description;
        entity.organization = data.organization ? Organization.fromPOJO(data.organization) : undefined;
        entity.restrictionType = data.restrictionType;
        entity.restrictedSources = data.restrictedSources?.map((item: object) => VulSource.fromPOJO(item));
        entity.restrictedView = data.restrictedView ? VulView.fromPOJO(data.restrictedView) : undefined;
        entity.generatedAiAttributeId = data.generatedAiAttributeId;
        entity.generatedAiExtractorId = data.generatedAiExtractorId;
        entity.generatedVulViewId = data.generatedVulViewId;

        return entity;
    }
}

export default Interest;
